<script lang="ts" setup>
import { useActiveOrganization } from 'auth-package'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import Invites from '@/components/settings/Invites.vue'
import { useInvitationManagerStore } from '@/stores/setting/Invitation'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'

defineOptions({ name: 'OrganizationMembers' })

const activeOrganization = useActiveOrganization()
const invitationStore = useInvitationManagerStore()
const { t } = i18n.global

function invitationSuccess() {
    invitationStore.getInvitationList(activeOrganization.value.uuid)

    ElMessage({
        type: 'success',
        message: t('settings.invitation.success')
    })
}
</script>

<template>
    <DefaultLayout :title="$t('settings.members', { name: activeOrganization?.name })">
        <priz-resource-user-manager
            :resourceId="'organization-' + activeOrganization.uuid"
            :showInvite="true"
            @invitationSuccess="invitationSuccess"
            resourceType="organization"
        />

        <h2>{{ $t('settings.invitation.title') }}</h2>

        <Invites />
    </DefaultLayout>
</template>

<style lang="scss" scoped></style>
